module.exports = __webpack_public_path__ + "static/img/img-dg.ab8d855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/mob/img-dg.png
// module id = 8mil
// module chunks = 0